import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { db, storage } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

import { Button, Modal, ModalBody, Input } from "reactstrap";

import Select from "react-select";
import makeAnimated from "react-select/animated";

function AdminSingleRewardPage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const rewardUid = params.rewardUid;

  const [rewardObject, setRewardObject] = useState();
  const [image, setImage] = useState();
  const [name, setName] = useState();
  const [priceInTickets, setPriceInTickets] = useState();
  const [countries, setCountries] = useState();
  const [quantityAvailable, setQuantityAvailable] = useState();
  const [totalQuantity, setTotalQuantity] = useState();
  const [disclaimer, setDisclaimer] = useState();
  const [isActive, setIsActive] = useState(false);

  const fetchReward = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "rewards"), where("uid", "==", rewardUid));
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setRewardObject(data);
      setImage(data.image);
      setName(data.name);
      setPriceInTickets(data.priceInTickets);
      setCountries(data.countries);

      setQuantityAvailable(data.quantityAvailable);
      setTotalQuantity(data.totalQuantity);

      setDisclaimer(data.disclaimer);

      setIsActive(data.isActive);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching reward data");
    }
  };

  useEffect(() => {
    if (rewardUid) {
      fetchReward();
    }
    // eslint-disable-next-line
  }, [rewardUid]);

  const saveChanges = () => {
    Swal.fire({
      text: "Are you sure you want to save your changes to this reward?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SAVE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const rewardRef = query(
            collection(db, "rewards"),
            where("uid", "==", rewardUid)
          );
          const findRewards = await getDocs(rewardRef);
          findRewards.forEach(async (rewardObject) => {
            const getReward = doc(db, "rewards", rewardObject.id);
            await updateDoc(getReward, {
              name: name,
              priceInTickets: parseInt(priceInTickets),
              countries: countries,
              quantityAvailable: parseInt(quantityAvailable),
              totalQuantity: parseInt(totalQuantity),
              disclaimer: disclaimer,
              isActive: isActive === "true" ? true : false,
            }).then(() => {
              fetchReward();
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          setIsLoading(false);
        }
      }
    });
  };

  const deleteReward = async () => {
    Swal.fire({
      text: "Are you sure you want to delete this reward?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, DELETE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const rewardRef = query(
            collection(db, "rewards"),
            where("uid", "==", rewardUid)
          );
          const findRewards = await getDocs(rewardRef);
          findRewards.forEach(async (rewardObject) => {
            const getRewards = doc(db, "rewards", rewardObject.id);
            await deleteDoc(getRewards);
          });

          Swal.fire({
            text: "Reward deleted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          navigate(-1);

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting reward");
        }
      }
    });
  };

  const [changeRewardImageModalIsOpen, setChangeRewardImageModalIsOpen] =
    useState(false);
  const toggleChangeRewardImageModal = () => {
    setChangeRewardImageModalIsOpen(!changeRewardImageModalIsOpen);
  };
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [newRewardImage, setNewRewardImage] = useState();
  const [newRewardImagePreview, setNewRewardImagePreview] = useState();

  const handleChangeNewRewardImage = (e) => {
    setNewRewardImage(e.target.files[0]);
    setNewRewardImagePreview(URL.createObjectURL(e.target.files[0]));
  };

  const selectNewRewardImage = () => {
    document.getElementById("selectImage").click();
  };

  const handleUploadNewRewardImage = async () => {
    const storageRef = ref(storage, `assets/rewards/${newRewardImage.name}`);
    const uploadTask = uploadBytesResumable(storageRef, newRewardImage);
    setIsModalLoading(true);
    uploadTask.on(
      "state_changed",
      null,
      (error) => console.log(error),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          console.log("File available at", downloadURL);
          try {
            setNewRewardImage(downloadURL);

            const rewardRef = query(
              collection(db, "rewards"),
              where("uid", "==", rewardUid)
            );
            const findRewards = await getDocs(rewardRef);
            findRewards.forEach(async (reward) => {
              const getReward = doc(db, "rewards", reward.id);
              await updateDoc(getReward, {
                image: downloadURL,
              });
            });

            fetchReward();

            setIsModalLoading(false);
            toggleChangeRewardImageModal();
          } catch (err) {
            console.error(err);
            alert(err.message);
            setIsModalLoading(false);
          }
        });
      }
    );
  };

  const animatedComponents = makeAnimated();

  const countryOptions = [
    { value: "Afghanistan", label: "Afghanistan" },
    { value: "Albania", label: "Albania" },
    { value: "Algeria", label: "Algeria" },
    { value: "Andorra", label: "Andorra" },
    { value: "Angola", label: "Angola" },
    { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
    { value: "Argentina", label: "Argentina" },
    { value: "Armenia", label: "Armenia" },
    { value: "Australia", label: "Australia" },
    { value: "Austria", label: "Austria" },
    { value: "Azerbaijan", label: "Azerbaijan" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "Barbados", label: "Barbados" },
    { value: "Belarus", label: "Belarus" },
    { value: "Belgium", label: "Belgium" },
    { value: "Belize", label: "Belize" },
    { value: "Benin", label: "Benin" },
    { value: "Bhutan", label: "Bhutan" },
    { value: "Bolivia", label: "Bolivia" },
    { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
    { value: "Botswana", label: "Botswana" },
    { value: "Brazil", label: "Brazil" },
    { value: "Brunei", label: "Brunei" },
    { value: "Bulgaria", label: "Bulgaria" },
    { value: "Burkina Faso", label: "Burkina Faso" },
    { value: "Burundi", label: "Burundi" },
    { value: "Cabo Verde", label: "Cabo Verde" },
    { value: "Cambodia", label: "Cambodia" },
    { value: "Cameroon", label: "Cameroon" },
    { value: "Canada", label: "Canada" },
    { value: "Central African Republic", label: "Central African Republic" },
    { value: "Chad", label: "Chad" },
    { value: "Chile", label: "Chile" },
    { value: "China", label: "China" },
    { value: "Colombia", label: "Colombia" },
    { value: "Comoros", label: "Comoros" },
    { value: "Congo", label: "Congo" },
    { value: "Costa Rica", label: "Costa Rica" },
    { value: "Croatia", label: "Croatia" },
    { value: "Cuba", label: "Cuba" },
    { value: "Cyprus", label: "Cyprus" },
    { value: "Czech Republic", label: "Czech Republic" },
    { value: "Denmark", label: "Denmark" },
    { value: "Djibouti", label: "Djibouti" },
    { value: "Dominica", label: "Dominica" },
    { value: "Dominican Republic", label: "Dominican Republic" },
    { value: "East Timor (Timor-Leste)", label: "East Timor (Timor-Leste)" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Egypt", label: "Egypt" },
    { value: "El Salvador", label: "El Salvador" },
    { value: "Equatorial Guinea", label: "Equatorial Guinea" },
    { value: "Eritrea", label: "Eritrea" },
    { value: "Estonia", label: "Estonia" },
    { value: "Eswatini", label: "Eswatini" },
    { value: "Ethiopia", label: "Ethiopia" },
    { value: "Fiji", label: "Fiji" },
    { value: "Finland", label: "Finland" },
    { value: "France", label: "France" },
    { value: "Gabon", label: "Gabon" },
    { value: "Gambia", label: "Gambia" },
    { value: "Georgia", label: "Georgia" },
    { value: "Germany", label: "Germany" },
    { value: "Ghana", label: "Ghana" },
    { value: "Greece", label: "Greece" },
    { value: "Grenada", label: "Grenada" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Guinea", label: "Guinea" },
    { value: "Guinea-Bissau", label: "Guinea-Bissau" },
    { value: "Guyana", label: "Guyana" },
    { value: "Haiti", label: "Haiti" },
    { value: "Honduras", label: "Honduras" },
    { value: "Hungary", label: "Hungary" },
    { value: "Iceland", label: "Iceland" },
    { value: "India", label: "India" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Iran", label: "Iran" },
    { value: "Iraq", label: "Iraq" },
    { value: "Ireland", label: "Ireland" },
    { value: "Israel", label: "Israel" },
    { value: "Italy", label: "Italy" },
    { value: "Jamaica", label: "Jamaica" },
    { value: "Japan", label: "Japan" },
    { value: "Jordan", label: "Jordan" },
    { value: "Kazakhstan", label: "Kazakhstan" },
    { value: "Kenya", label: "Kenya" },
    { value: "Kiribati", label: "Kiribati" },
    { value: "Korea, North", label: "Korea, North" },
    { value: "Korea, South", label: "Korea, South" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Kyrgyzstan", label: "Kyrgyzstan" },
    { value: "Laos", label: "Laos" },
    { value: "Latvia", label: "Latvia" },
    { value: "Lebanon", label: "Lebanon" },
    { value: "Lesotho", label: "Lesotho" },
    { value: "Liberia", label: "Liberia" },
    { value: "Libya", label: "Libya" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Lithuania", label: "Lithuania" },
    { value: "Luxembourg", label: "Luxembourg" },
    { value: "Madagascar", label: "Madagascar" },
    { value: "Malawi", label: "Malawi" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Maldives", label: "Maldives" },
    { value: "Mali", label: "Mali" },
    { value: "Malta", label: "Malta" },
    { value: "Marshall Islands", label: "Marshall Islands" },
    { value: "Mauritania", label: "Mauritania" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Mexico", label: "Mexico" },
    { value: "Micronesia", label: "Micronesia" },
    { value: "Moldova", label: "Moldova" },
    { value: "Monaco", label: "Monaco" },
    { value: "Mongolia", label: "Mongolia" },
    { value: "Montenegro", label: "Montenegro" },
    { value: "Morocco", label: "Morocco" },
    { value: "Mozambique", label: "Mozambique" },
    { value: "Myanmar", label: "Myanmar" },
    { value: "Namibia", label: "Namibia" },
    { value: "Nauru", label: "Nauru" },
    { value: "Nepal", label: "Nepal" },
    { value: "Netherlands", label: "Netherlands" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Niger", label: "Niger" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "North Macedonia", label: "North Macedonia" },
    { value: "Norway", label: "Norway" },
    { value: "Oman", label: "Oman" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Palau", label: "Palau" },
    { value: "Palestine", label: "Palestine" },
    { value: "Panama", label: "Panama" },
    { value: "Papua New Guinea", label: "Papua New Guinea" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Peru", label: "Peru" },
    { value: "Philippines", label: "Philippines" },
    { value: "Poland", label: "Poland" },
    { value: "Portugal", label: "Portugal" },
    { value: "Qatar", label: "Qatar" },
    { value: "Romania", label: "Romania" },
    { value: "Russia", label: "Russia" },
    { value: "Rwanda", label: "Rwanda" },
    { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
    { value: "Saint Lucia", label: "Saint Lucia" },
    {
      value: "Saint Vincent and the Grenadines",
      label: "Saint Vincent and the Grenadines",
    },
    { value: "Samoa", label: "Samoa" },
    { value: "San Marino", label: "San Marino" },
    { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
    { value: "Saudi Arabia", label: "Saudi Arabia" },
    { value: "Senegal", label: "Senegal" },
    { value: "Serbia", label: "Serbia" },
    { value: "Seychelles", label: "Seychelles" },
    { value: "Sierra Leone", label: "Sierra Leone" },
    { value: "Singapore", label: "Singapore" },
    { value: "Slovakia", label: "Slovakia" },
    { value: "Slovenia", label: "Slovenia" },
    { value: "Solomon Islands", label: "Solomon Islands" },
    { value: "Somalia", label: "Somalia" },
    { value: "South Africa", label: "South Africa" },
    { value: "South Sudan", label: "South Sudan" },
    { value: "Spain", label: "Spain" },
    { value: "Sri Lanka", label: "Sri Lanka" },
    { value: "Sudan", label: "Sudan" },
    { value: "Suriname", label: "Suriname" },
    { value: "Sweden", label: "Sweden" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "Syria", label: "Syria" },
    { value: "Taiwan", label: "Taiwan" },
    { value: "Tajikistan", label: "Tajikistan" },
    { value: "Tanzania", label: "Tanzania" },
    { value: "Thailand", label: "Thailand" },
    { value: "Togo", label: "Togo" },
    { value: "Tonga", label: "Tonga" },
    { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
    { value: "Tunisia", label: "Tunisia" },
    { value: "Turkey", label: "Turkey" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Tuvalu", label: "Tuvalu" },
    { value: "Uganda", label: "Uganda" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "United Arab Emirates", label: "United Arab Emirates" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "United States", label: "United States" },
    { value: "Uruguay", label: "Uruguay" },
    { value: "Uzbekistan", label: "Uzbekistan" },
    { value: "Vanuatu", label: "Vanuatu" },
    { value: "Vatican City", label: "Vatican City" },
    { value: "Venezuela", label: "Venezuela" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Yemen", label: "Yemen" },
    { value: "Zambia", label: "Zambia" },
    { value: "Zimbabwe", label: "Zimbabwe" },
  ];

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        REWARD
      </h1>
      <div>
        <div
          onClick={toggleChangeRewardImageModal}
          id="adminNewsArticleImageContainer"
        >
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
          <div className="adminNewsArticleImageOverlay">
            <Button className="primaryBtn">CHANGE</Button>
          </div>
        </div>
        <Modal
          id="changeNewsArticleImageModal"
          isOpen={changeRewardImageModalIsOpen}
          toggle={toggleChangeRewardImageModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader" style={{ marginBottom: "1rem" }}>
              <div></div>
              <IoClose onClick={toggleChangeRewardImageModal} />
            </div>
            <div>
              <h1>CHANGE IMAGE</h1>
              {isModalLoading ? (
                <div
                  style={{
                    height: 300,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BarLoader color="#005EE1" />
                </div>
              ) : (
                <div style={{ marginTop: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "1rem",
                    }}
                  >
                    <img
                      alt="articleImage"
                      src={
                        newRewardImagePreview
                          ? newRewardImagePreview
                          : image
                          ? image
                          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                      }
                      style={{ height: 250, width: 651.4 }}
                    />
                  </div>
                  <Input
                    id="selectImage"
                    type="file"
                    className="mainInput"
                    accept="image/*"
                    onChange={handleChangeNewRewardImage}
                    style={{ display: "none" }}
                  />
                  <Button
                    onClick={selectNewRewardImage}
                    className="secondaryBtn"
                    style={{ marginBottom: "0.5rem", color: "#005EE1" }}
                  >
                    {newRewardImage?.name
                      ? newRewardImage.name
                      : "CHOOSE IMAGE (1,398x1,017px)"}
                  </Button>
                  <Button
                    onClick={handleUploadNewRewardImage}
                    disabled={!newRewardImage?.name}
                    className="primaryBtn"
                  >
                    CHANGE
                  </Button>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="The rewards's name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Price in tickets
        </p>
        <input
          type="number"
          className="mainInput"
          value={priceInTickets}
          onChange={(e) => setPriceInTickets(e.target.value)}
          placeholder="The reward's price in tickets"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Countries
        </p>
        <Select
          closeMenuOnSelect={false}
          components={animatedComponents}
          isMulti
          options={countryOptions}
          value={countries}
          onChange={(e) => setCountries(e)}
          className="selectInput"
          placeholder="The reward's countries"
        />
        <p
          className="inputLabel"
          style={{ textAlign: "left", marginTop: "0.5rem" }}
        >
          Quantity available
        </p>
        <input
          type="number"
          className="mainInput"
          value={quantityAvailable}
          onChange={(e) => setQuantityAvailable(e.target.value)}
          placeholder="The quantity available for this reward"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Total quantity
        </p>
        <input
          type="number"
          className="mainInput"
          value={totalQuantity}
          onChange={(e) => setTotalQuantity(e.target.value)}
          placeholder="The total quantity for this reward"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Disclaimer
        </p>
        <textarea
          className="mainInput"
          value={disclaimer}
          onChange={(e) => setDisclaimer(e.target.value)}
          placeholder="The reward's disclaimer"
          style={{ marginBottom: "0.5rem", paddingTop: 15, height: 200 }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Is active
        </p>
        <select
          className="mainInput"
          value={isActive}
          onChange={(e) => setIsActive(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value={true}>Yes</option>
          <option value={false}>No</option>
        </select>
        <Button
          onClick={saveChanges}
          className="primaryBtn"
          style={{ marginTop: "1rem" }}
          disabled={
            name === rewardObject?.name &&
            parseInt(priceInTickets) === rewardObject?.priceInTickets &&
            countries === rewardObject?.countries &&
            quantityAvailable === rewardObject.quantityAvailable &&
            totalQuantity === rewardObject.totalQuantity &&
            disclaimer === rewardObject.disclaimer &&
            isActive === rewardObject.isActive
          }
        >
          SAVE
        </Button>
        <Button
          onClick={deleteReward}
          className="secondaryBtn"
          style={{ marginTop: "0.5rem" }}
        >
          DELETE
        </Button>
      </div>
    </div>
  );
}

export default AdminSingleRewardPage;
